// src/components/Report/shared/StudentRow.jsx
import React from "react";
import { motion } from "framer-motion";
import { hex2rgba, gradeBadge } from "./reportUtils";

export default function StudentRow({ rank, name, avgPct, isSelected, onClick, isTop }) {
  const badge = gradeBadge(avgPct);
  const barColor = isTop ? "#059669" : "#ef4444";

  return (
    <motion.div
      onClick={onClick}
      whileHover={{ x: 3 }}
      style={{
        display: "flex", alignItems: "center", gap: 10, padding: "7px 10px", borderRadius: 8,
        cursor: "pointer", marginBottom: 4,
        background: isSelected ? hex2rgba(barColor, 0.08) : "transparent",
        border: `1px solid ${isSelected ? hex2rgba(barColor, 0.3) : "transparent"}`,
      }}
    >
      <span style={{
        width: 24, textAlign: "center", fontWeight: 700, fontSize: 12, flexShrink: 0,
        color: isTop && rank <= 3 ? ["#f59e0b", "#94a3b8", "#b45309"][rank - 1] : "#94a3b8",
      }}>
        {isTop && rank <= 3 ? ["🥇", "🥈", "🥉"][rank - 1] : `#${rank}`}
      </span>
      <span style={{
        flex: 1, fontSize: 12, fontWeight: 600, color: "#1e293b",
        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
      }}>
        {name}
      </span>
      <div style={{ width: 72, height: 6, borderRadius: 4, background: "#f1f5f9", flexShrink: 0 }}>
        <motion.div
          initial={{ width: 0 }} animate={{ width: `${avgPct}%` }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          style={{ height: "100%", borderRadius: 4, background: barColor }}
        />
      </div>
      <span style={{
        fontSize: 11, fontWeight: 700, color: badge.color,
        background: hex2rgba(badge.color, 0.1), borderRadius: 4, padding: "1px 6px", flexShrink: 0,
      }}>
        {badge.label} {avgPct}%
      </span>
    </motion.div>
  );
}